// Parent/student homework (native /homework pages). Globally unique — the
// school-side homework actions use the unprefixed names.
export const STUDENT_HOMEWORK_LIST = 'STUDENT_HOMEWORK_LIST'
export const STUDENT_HOMEWORK_DETAIL = 'STUDENT_HOMEWORK_DETAIL'
export const STUDENT_HOMEWORK_UPLOAD_URL = 'STUDENT_HOMEWORK_UPLOAD_URL'
export const STUDENT_HOMEWORK_CONFIRM_FILE = 'STUDENT_HOMEWORK_CONFIRM_FILE'
export const STUDENT_HOMEWORK_SUBMIT = 'STUDENT_HOMEWORK_SUBMIT'
export const STUDENT_HOMEWORK_DELETE_FILE = 'STUDENT_HOMEWORK_DELETE_FILE'
// mobile-parity additions: the subject filter of the list and the homework's
// comment thread with the teacher (mobile `Chat` screen, module_type 0)
export const STUDENT_HOMEWORK_SUBJECTS = 'STUDENT_HOMEWORK_SUBJECTS'
export const STUDENT_HOMEWORK_MESSAGES = 'STUDENT_HOMEWORK_MESSAGES'
export const STUDENT_HOMEWORK_SEND_MESSAGE = 'STUDENT_HOMEWORK_SEND_MESSAGE'
